<div class="modal-header px-4 justify-content-between">
  <h4 class="modal-title header-13">
    {{ configs.title }}
  </h4>
  <div>
    <button type="button" class="btn-close btn-close-white" aria-label="Close"
      (click)="activeModal.dismiss('Cross click')"></button>
  </div>
</div>

<div class="modal-body w-100 d-flex flex-column">
  <div class="header d-flex justify-content-between">
    <div class="d-flex">
      <div class="row search-tree m-auto">
        <input type="text" class="search-input form-control" [(ngModel)]="testcaseSearch" (keyup)="searchTestCases()"
          placeholder="Search Test Suite or Test Case" />
      </div>
      <span class="general-text-2 m-auto">{{selectedDataList?.length || 0}} test cases selected out of {{allTestCases?.length || 0}}</span>
    </div>
    <div class="d-flex">
      <span class="general-text-16 m-auto">Show only selected</span>
      <div class="form-check form-switch m-auto toggel-section">
        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" (change)="onToggleChange($event)"/>
      </div>
    </div>
  </div>
  <div class="body mt-1 d-flex">
    @if (isDataLoading) {
    <app-loading class="h-100 loading-container m-auto" [text]="'Loading'"></app-loading>
    } @else {
    <app-zorro-table tableId="llm-tc-modal" class="w-100" [columns]="columnsDetails" [data]="tastcaseDetails"
      (handleActions)="onTableActinChange($event)" (onRowSelect)="handleRowSelection($event)"></app-zorro-table>
    }
  </div>
  <div class="footer d-flex justify-content-end mt-2">
    <button class="btn-accello-primary-outlined align-items-center mx-2 m-auto" (click)="onDiscardSelectedItems()">
      Cancel
    </button>
    <button class="btn btn-accello-primary mx-2 btn-spin m-auto me-0" (click)="addTestCases()">
      <span>Add</span>
      @if(isProcessing){
      <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
      }
    </button>
  </div>
</div>